import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { slot: "footer" }
const _hoisted_5 = { class: "discard-message" }
const _hoisted_6 = ["disabled"]

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import { useDeleteNamespace } from '../../queries/useNamespaceMutations';
import { Namespace } from '../../models/namespace/api-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'NamespaceDeleteModal',
  setup(__props, { expose: __expose }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

// Modal open state
const showModal = ref(false);

// Form fields (separate from the model to avoid proxy mutation issues)
const deleteNamespaceInput = ref<HTMLElement | null>(null);
const confirmDeleteInput = ref<string>('');
const namespaceToDelete = ref<Namespace | null>(null);

const {mutate: deleteNamespace, isPending: isDeletingNamespace, isError: deleteNamespaceError, error: deleteNamespaceErrorData} = useDeleteNamespace(store, closeModal);

const showDiscardConfirm = ref(false);

const validationPassed = computed(() => {
   return confirmDeleteInput.value === namespaceToDelete.value?.meta.name;
});

function openDelete(namespace: Namespace) {
  namespaceToDelete.value = namespace;
  showModal.value = true;
}

function handleModalClose() {
  if (namespaceToDelete.value) {
    showDiscardConfirm.value = true;
  } else {
    closeModal();
  }
}

function handleKeepEditing() {
  showDiscardConfirm.value = false;
}

function handleDiscard() {
  showDiscardConfirm.value = false;
  closeModal();
}

function closeModal() {
  showModal.value = false;
  namespaceToDelete.value = null;
  confirmDeleteInput.value = '';
}

async function onSubmit() {
  if (!namespaceToDelete.value) {
    return;
  }
  deleteNamespace(namespaceToDelete.value.meta.name);
}

__expose({ openDelete });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: "Are you sure?",
    dismissible: false,
    onModalOpen: _cache[2] || (_cache[2] = () => deleteNamespaceInput.value?.focus()),
    onModalClose: closeModal
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(t)('epinio.namespace.attemptDelete')) + " ", 1),
        _createElementVNode("strong", null, _toDisplayString(namespaceToDelete.value?.meta.name), 1),
        _cache[3] || (_cache[3] = _createTextVNode(".", -1))
      ]),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createVNode(Banner, {
        color: "warning",
        label: _unref(t)('epinio.namespace.deleteWarning')
      }, null, 8, ["label"]),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(t)('epinio.namespace.confirmDelete')) + " ", 1),
        _createElementVNode("strong", null, _toDisplayString(namespaceToDelete.value?.meta.name), 1),
        _cache[4] || (_cache[4] = _createTextVNode(":", -1))
      ]),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-text-input", {
        ref_key: "deleteNamespaceInput",
        ref: deleteNamespaceInput,
        value: confirmDeleteInput.value,
        size: "large",
        onTextInputChange: _cache[0] || (_cache[0] = ($event: any) => (confirmDeleteInput.value = $event.detail.value)),
        onKeydown: _cache[1] || (_cache[1] = (e) => { if (e.key === 'Enter' && validationPassed.value) onSubmit(); })
      }, null, 40, _hoisted_3),
      _cache[8] || (_cache[8] = _createTextVNode()),
      (_unref(deleteNamespaceError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: _unref(deleteNamespaceErrorData)?.message || _unref(t)('epinio.namespace.errors.delete')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[12] || (_cache[12] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      (showDiscardConfirm.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('epinio.unsavedChanges.warning')), 1),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "secondary",
              class: "mr-10",
              onButtonClick: handleKeepEditing
            }, _toDisplayString(_unref(t)('generic.keepEditing')), 33),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "destructive",
              onButtonClick: handleDiscard
            }, _toDisplayString(_unref(t)('generic.discard')), 33)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("trailhand-button", {
              variant: "secondary",
              class: "mr-10",
              onButtonClick: handleModalClose
            }, _toDisplayString(_unref(t)('generic.cancel')), 33),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "primary",
              disabled: !validationPassed.value || _unref(isDeletingNamespace),
              onButtonClick: onSubmit
            }, _toDisplayString(_unref(isDeletingNamespace) ? _unref(t)('generic.deleting') : _unref(t)('generic.delete')), 41, _hoisted_6)
          ], 64))
    ])
  ], 40, _hoisted_1))
}
}

})